// removed by extract-text-webpack-plugin
module.exports = {"root":"root___3LOTX"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Merchant/Commodity/Table.less
// module id = Fb7Q
// module chunks = 18